import { createContext, useContext } from "react";

import type { CustomMailSettingTestMailInput } from "@/lib/gql/__generated__/graphql";

import { ProductDayTripPlanFormModelContext } from "../../_shared/context/context";

import type { ProductDayTripPlanFormModelContextType } from "../../_shared/context/context";

export type ProductExistingDayTripPlanFormModelContextType = {
	onUpdate: () => void;

	testEmailSender: {
		sendTestMailAtReservationCreate: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtReservationUpdate: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtReservationCancel: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore07Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore01Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore00Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckOutAfter01Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
	};
} & ProductDayTripPlanFormModelContextType;

export const ProductExistingDayTripPlanFormModelContext =
	createContext<ProductExistingDayTripPlanFormModelContextType | null>(null);

export const ProductExistingDayTripPlanFormModelContextProvider = ({
	value,
	children,
}: {
	value: ProductExistingDayTripPlanFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<ProductExistingDayTripPlanFormModelContext.Provider value={value}>
			<ProductDayTripPlanFormModelContext.Provider value={value}>
				{children}
			</ProductDayTripPlanFormModelContext.Provider>
		</ProductExistingDayTripPlanFormModelContext.Provider>
	);
};

export const useProductExistingDayTripPlanFormModelContext = () => {
	const context = useContext(ProductExistingDayTripPlanFormModelContext);

	if (!context) {
		throw new Error(
			"useProductExistingDayTripPlanFormModelContext must be used within a ProductExistingDayTripPlanFormModelContextProvider",
		);
	}

	return {
		...context,
	};
};
